import { RouteConfig } from 'vue-router'

import CcpHomeView from '../Views/Home/Home.vue';


const routes: Array<RouteConfig> = [
  {
    path: '/ccp',
    name: 'cpp',
    component: CcpHomeView,
  }

];

export default routes
